export default "__VITE_ASSET__Ds4GL$F2__"